import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20romantic%20abstract%20gradient%20background%20with%20soft%20rose%20gold%20and%20cream%20tones%2C%20elegant%20flowing%20shapes%2C%20minimalist%20aesthetic%2C%20dreamy%20atmosphere%2C%20artistic%20abstract%20composition%2C%20smooth%20textures%2C%20luxurious%20feel&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="爱情岛独家 - 高品质内容平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-6">
          <span className="inline-block px-4 py-1.5 text-xs font-medium text-white/90 bg-white/15 backdrop-blur-sm rounded-full border border-white/20">
            安全稳定 · 持续更新 · 品质保证
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          爱情岛独家
          <span className="block text-xl md:text-2xl lg:text-3xl font-body font-normal mt-3 text-white/85">
            最权威、最私密的独家内容体验平台
          </span>
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇聚海量精选资源，带给您与众不同的专属享受。独家精品、高清画质、实时更新，
          满足您对高品质内容的全部期待。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/exclusive"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-full transition-all duration-300 whitespace-nowrap text-base"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium rounded-full transition-all duration-300 whitespace-nowrap text-base border border-white/30"
          >
            了解更多
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mt-12">
          {[
            { value: '12,000+', label: '精选内容' },
            { value: '80万+', label: '月活用户' },
            { value: '6', label: '核心品类' },
            { value: '99.9%', label: '服务稳定性' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
              <div className="text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}